module.exports = __webpack_public_path__ + "img/Group 15.d223334.svg";